import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import { getAssetUrl } from '../../../utils/config';
import EllipsisText from '../../atoms/EllipsisText';
import LoadingIndicator from '../../atoms/LoadingIndicator';
import Price, { PriceProps } from '../../atoms/Price';

type PriceSectionProps = PriceProps & {
  name: string;
  label: string;
  isFree?: boolean;
  isRemovable?: { isLoading: boolean; isDisabled: boolean; onRemove: () => void };
  showIncludesTax?: boolean;
};

const PriceSection = ({ label, name, isFree, isRemovable, showIncludesTax, ...priceProps }: PriceSectionProps) => (
  <dl className={`price-summary__section price-summary__section--${name}`} data-test-id={`price-summary-${name}`}>
    <EllipsisText className="price-summary__section__name">{label}</EllipsisText>
    <dd>
      <div className={classNames({ 'price-summary--removable': isRemovable })}>
        {isFree ?
          <div data-test-id={`basket-${name}`}>
            <FormattedMessage id="generic.free" />
          </div>
        : <>
            <Price {...priceProps} dataTestId={`basket-${name}`} />
            {showIncludesTax && (
              <div className="price-summary--includingTax" data-test-id="including-tax">
                <FormattedMessage id="basket.includingTax" />
              </div>
            )}
          </>
        }
        {isRemovable && (
          <div className="price-summary__loading-container">
            <LoadingIndicator
              isSmall
              contentClassName={classNames('price-summary__loading', {
                'price-summary__loading--visible': isRemovable.isLoading
              })}
              data-test-id="price-summary-loading-icon"
            />
            <img
              src={getAssetUrl('common/remove.svg')}
              className={classNames('price-summary--removable__img', {
                'price-summary--removable__img--loading': isRemovable.isLoading,
                'cursor-disabled': isRemovable.isDisabled
              })}
              onClick={() => !isRemovable.isDisabled && isRemovable.onRemove()}
              data-test-id="price-summary-remove-icon"
            />
          </div>
        )}
      </div>
    </dd>
  </dl>
);
export default PriceSection;
